import React, { Component } from 'react';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

class AddMeldingMap extends Component {
	state = {  };

	render() {
		const { props, state } = this;
		return (
			<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['marker']}>
				<Map
					style={{ height: 250 }}
					mapId={"meldingMap"}
					defaultZoom={14}
					defaultCenter={{
						lat: props.location.lat,
						lng: props.location.lng
					}}
					clickableIcons={false}
					onClick={props.onClickMap}
				>
					{props.meldingLocation && (
						<Marker
							position={props.meldingLocation}
						/>
					)}

				</Map>
			</APIProvider>
		);
	}
}

export default AddMeldingMap;

/*
					<HeatmapLayer
						data={props.heatmapPoints}
						options={{
							dissipating: true,
							maxIntensity: this.props.heatmapMaxIntensity
						}} />*/
